import { useEffect, useState } from 'react';

import { useNavigationProgress } from './navigation-progress-context';

export function NavigationProgressBar() {
  const { isNavigating } = useNavigationProgress();
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;

    if (isNavigating) {
      setVisible(true);
      setProgress(0);

      // Simulate progress - fast at first, then slower
      intervalId = setInterval(() => {
        setProgress((prev) => {
          if (prev < 30) return prev + 10;
          if (prev < 60) return prev + 5;
          if (prev < 80) return prev + 2;
          if (prev < 95) return prev + 0.5;
          return prev; // Stay at 95 until complete
        });
      }, 100);
    } else if (visible) {
      // Complete the progress bar
      setProgress(100);

      // Hide after animation completes
      const hideTimeout = setTimeout(() => {
        setVisible(false);
        setProgress(0);
      }, 300);

      return () => clearTimeout(hideTimeout);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isNavigating, visible]);

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        height: 3,
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          height: '100%',
          width: `${progress}%`,
          backgroundColor: '#ff850a',
          transition: 'width 100ms ease-out',
        }}
      />
    </div>
  );
}
